import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0aef506c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 1,
  class: "update-detail"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "des"
};
const _hoisted_4 = {
  key: 0,
  src: "https://p6.moimg.net/mdwxapp/update_activity.png"
};
const _hoisted_5 = {
  key: 1,
  src: "https://p6.moimg.net/mdwxapp/update_activity_help.png"
};
const _hoisted_6 = {
  class: "time"
};
const _hoisted_7 = {
  class: "user"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "name"
};
const _hoisted_10 = {
  class: "title"
};
const _hoisted_11 = {
  class: "from-box"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "来源项目", -1));
const _hoisted_13 = {
  class: "render-line-clamp"
};
const _hoisted_14 = ["src"];
const _hoisted_15 = {
  key: 2,
  class: "appraise"
};
const _hoisted_16 = ["src", "onClick"];
const _hoisted_17 = {
  class: "icon"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Error = _resolveComponent("Error");
  const _component_CompClientDetail = _resolveComponent("CompClientDetail");
  return $data.showError ? (_openBlock(), _createBlock(_component_Error, {
    key: 0,
    message: $data.showMessage,
    img: "icon_nodynamic",
    needLogin: true
  }, null, 8, ["message"])) : (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("img", {
    src: $data.update_info.logo
  }, null, 8, _hoisted_2), _createElementVNode("div", _hoisted_3, [_createElementVNode("span", null, _toDisplayString($data.update_info.num), 1), $data.update_info.type == 2 ? (_openBlock(), _createElementBlock("img", _hoisted_4)) : $data.update_info.type == 3 ? (_openBlock(), _createElementBlock("img", _hoisted_5)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_6, _toDisplayString($data.update_info.ctime), 1)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
    src: $data.user_info.icon ? $data.user_info.icon : 'https://s.moimg.net/new/images/headPic.png'
  }, null, 8, _hoisted_8), _createElementVNode("div", _hoisted_9, _toDisplayString($data.user_info.username), 1)]), _createElementVNode("div", _hoisted_10, _toDisplayString($data.update_info.title), 1), $data.update_info && JSON.stringify($data.update_info) != '{}' ? (_openBlock(), _createBlock(_component_CompClientDetail, {
    key: 0,
    noPost: true,
    "update-info": $data.update_info
  }, null, 8, ["update-info"])) : _createCommentVNode("", true), Number($data.product_info.pro_class) != 102 ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "project-detail",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.goPro && $options.goPro(...args))
  }, [_createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("div", _hoisted_13, _toDisplayString($data.update_info.pro_title), 1)]), _createElementVNode("img", {
    src: $data.update_info.pro_cover
  }, null, 8, _hoisted_14)])) : _createCommentVNode("", true), $data.update_info.like_count != 0 ? (_openBlock(), _createElementBlock("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.update_info.uid_list, (item, index) => {
    return _openBlock(), _createElementBlock("img", {
      class: "img",
      key: index,
      src: item.icon,
      onClick: _withModifiers($event => $options.toUserhome(item), ["stop"])
    }, null, 8, _hoisted_16);
  }), 128)), _createElementVNode("div", _hoisted_17, _toDisplayString($data.update_info.like_count) + "个赞", 1)])) : _createCommentVNode("", true)]));
}